import { EventEmitter } from "events";
import TCVelikClient from '@/TCVelikClient/TCVelikClient.js'

class DataService extends EventEmitter {
    GetAccountUsers(sort, filter, skip, take, employeesOnly){
      var employeesOnlyStr = employeesOnly ? "true":"";
      return TCVelikClient.GetRelative(`/api/Accounts/GetAccountUsers?sort=${sort}&filter=${filter}&skip=${skip}&take=${take}&employeesOnly=${employeesOnlyStr}`)
  }
}

export default new DataService();
